import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay, map, shareReplay, tap } from 'rxjs/operators';
import { appendQueryParams } from '../../../../utils/utils';
import {
  LoggedUserData,
  LoggedUserDataResponseDto,
  Login,
  LoginResponse,
  LoginResponseFromApi,
} from './login.model';

@Injectable()
export class LoginService {
  private loggedUserData: Observable<LoggedUserData>;
  private navigationToExternalLoginInProcess = new BehaviorSubject(false);
  navigationToExternalLoginInProcess$ =
    this.navigationToExternalLoginInProcess.asObservable();
  constructor(
    private httpClient: HttpClient,
    private translateService: TranslateService,
    private toastr: ToastrService,
    @Inject('window') public window: Window,
  ) {}

  login(
    data: Login,
    loginUrl = '/api/system/login',
  ): Observable<LoginResponse> {
    return this.httpClient
      .post<LoginResponseFromApi>(loginUrl, Login.fromAppToApi(data))
      .pipe(map((data) => LoginResponse.fromApiToApp(data)));
  }

  redirectToExternalLoginPageWithToastr(externalLoginUrl: string): void {
    this.translateService
      .get('SESSION_TOOLS.REDIRECT_TO_EXTERNAL_LOGIN')
      .pipe(
        tap((message) => {
          this.toastr.success(message);
        }),
        delay(3000),
      )
      .subscribe(() => {
        this.navigateToExternalLogin(externalLoginUrl);
      });
  }

  navigateToExternalLogin(
    externalLoginUrl: string,
    queryParams?: Record<string, any>,
  ): void {
    this.navigationToExternalLoginInProcess.next(true);
    const urlWithParams = appendQueryParams(externalLoginUrl, queryParams);
    this.window.location.href = urlWithParams;
  }

  getSystemLoggedUserData(): Observable<LoggedUserData> {
    if (!this.loggedUserData) {
      this.loggedUserData = this.httpClient
        .get<LoggedUserDataResponseDto>('/api/system/logged/user')
        .pipe(
          map((loggedUserFromApi) =>
            LoggedUserData.fromApiToApp(loggedUserFromApi),
          ),
          shareReplay(1),
        );
    }
    return this.loggedUserData;
  }
}
